import React from 'react';
import { PencilSquare, Trash } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';

import { Group } from '../../../domain/group';

type GroupsTableRowProps = {
    group: Group;
    onEdit: (group: Group) => void;
    onDelete: (id: string) => void;
}

export const GroupsTableRow = ({ group, onEdit, onDelete }: GroupsTableRowProps) => (
    <tr>
        <td>{group.name}</td>
        <td>{group.description}</td>
        <td>{group.permissions.length} uprawnień</td>
        <td className="text-end">
            <Button variant="link" size="sm" className="p-0 me-2" onClick={() => onEdit(group)}>
                <PencilSquare />
            </Button>
            <Button variant="link" size="sm" className="p-0 text-danger" onClick={() => onDelete(group.id)}>
                <Trash />
            </Button>
        </td>
    </tr>
);
